var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 10.2916C11.4372 10.2916 11.0834 10.6463 11.0834 11.0832V14.25C11.0834 14.6862 10.7287 15.0416 10.2916 15.0416H7.91662V3.16662C7.91662 2.49053 7.48595 1.88649 6.83842 1.66166L6.60402 1.58324H10.2916C10.7287 1.58324 11.0834 1.93867 11.0834 2.375V4.75C11.0834 5.1869 11.4372 5.54162 11.875 5.54162C12.3128 5.54162 12.6666 5.1869 12.6666 4.75V2.375C12.6666 1.06559 11.601 0 10.2916 0H1.78125C1.7511 0 1.72588 0.0134812 1.69659 0.017395C1.65847 0.0142059 1.62209 0 1.58338 0C0.710152 0 0 0.710007 0 1.58324V15.8332C0 16.5093 0.430672 17.1134 1.0782 17.3382L5.84255 18.9264C6.00404 18.9762 6.16465 19 6.33338 19C7.20661 19 7.91662 18.2898 7.91662 17.4166V16.625H10.2916C11.601 16.625 12.6666 15.5594 12.6666 14.25V11.0832C12.6666 10.6463 12.3128 10.2916 11.875 10.2916Z",
    fill: "#FF3232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7681 7.35582L15.6013 4.1892C15.375 3.96278 15.0345 3.89465 14.7385 4.01728C14.4432 4.14006 14.25 4.42897 14.25 4.74889V7.12389H11.0834C10.6463 7.12389 10.2916 7.47846 10.2916 7.91551C10.2916 8.35256 10.6463 8.70713 11.0834 8.70713H14.25V11.0821C14.25 11.402 14.4432 11.691 14.7385 11.8137C15.0345 11.9364 15.375 11.8682 15.6013 11.642L18.7681 8.47519C19.0776 8.16571 19.0776 7.66531 18.7681 7.35582Z",
    fill: "#FF3232"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.2e5b251ee6dff7733c5c1037cef1d9f5.svg";
export { ForwardRef as ReactComponent };